// extracted by mini-css-extract-plugin
export default {"title":"ExperiencePreview_title__OHIMF","date":"ExperiencePreview_date__AMidI"};